// dependencies
import { fromJS } from "immutable";

const baseAction = "DEPARTMENTS";

export function ParseGetGroup(groupID, group) {
	return (dispatch) => {
		/*
            Parses the group get
        */

		const groupObject = {
			_id: groupID,
			name: group.name,
			numUsers: group.numUsers,
		};

		dispatch({
			type: `${baseAction}:SETONE`,
			groupID,
			groupObject: fromJS(groupObject),
		});
	};
}

export function ParseDepartments(departmentList) {
	return (dispatch) => {
		/*
            Parses the department list.
        */

		const departmentMap = {};

		departmentList.forEach((departmentObject) => {
			const departmentId = departmentObject._id;
			departmentMap[departmentId] = departmentObject;
		});

		dispatch({
			type: `${baseAction}:SET`,
			departmentMap: fromJS(departmentMap),
		});
	};
}

export function ParseGroupSearchResponse(query, response) {
	return (dispatch) => {
		/*
            Parses the response from a group search API call.
        */

		const groupMap = {};
		const groupList = response.groups.map((group) => group.id);

		response.groups.forEach((group) => {
			const groupId = group.id;
			groupMap[groupId] = {
				_id: groupId,
				name: group.name,
				numUsers: group.numUsers,
			};
		});

		dispatch({
			type: `${baseAction}:SEARCH_PARSED`,
			query,
			groupList: fromJS(groupList),
			groupMap: fromJS(groupMap),
		});
	};
}

export function SearchGroups(query) {
	return (dispatch) => {
		//

		dispatch({ type: `${baseAction}:SEARCH`, query });
	};
}
